import { useCallback } from "react";

import styled from "styled-components";

import { useNetworkMetadata } from "Flocknote/apiHooks";

import { useMemberToobarContext } from "CrossFeatureComponents/MemberToolbar/MemberToolbarState";
import { contentKeys } from "CrossFeatureComponents/MemberToolbar/contentKeys";
import { useMemberToolbarStore } from "CrossFeatureComponents/MemberToolbar/memberToolbarStore";
import FnrTypography from "UI/FnrTypography";

import FnrNetworkPhoto from "UI/FnrNetworkPhoto";
import FnrTappyShrink from "UI/FnrTappyShrink";

import { useCopyTextColor } from "../stateHooks";

import MainOptionButtonWrapper from "./MainOptionButtonWrapper";

const GeneralInquiryButtonDisplay = () => {
  const [{ networkLogo }] = useNetworkMetadata();
  const [{ networkName }] = useNetworkMetadata();
  const textColor = useCopyTextColor();

  return (
    <Wrapper>
      <SFnrNetworkPhoto size="md" src={networkLogo} />
      <FnrTypography color={textColor} bold type="copy">
        Contact {networkName}
      </FnrTypography>
    </Wrapper>
  );
};

const SFnrNetworkPhoto = styled(FnrNetworkPhoto)`
  display: flex;
  justify-content: center;
  width: 40px;
  height: 24px;
  align-items: center;
`;

const Wrapper = styled(FnrTappyShrink)`
  display: flex;
  align-items: center;
  gap: 12px;
`;

const GeneralInquiryButton = () => {
  const { setActiveContentKey } = useMemberToolbarStore();
  const {
    flocknoteSupport,
    prayerRequest,
    generalInquiry,
    setFlocknoteSupport,
    setGeneralInquiry,
    setPrayerRequest,
  } = useMemberToobarContext();

  const showGeneralInquiry = useCallback(() => {
    setActiveContentKey(contentKeys.form);
    setGeneralInquiry(true);
    setFlocknoteSupport(false);
    setPrayerRequest(false);
  }, [
    setActiveContentKey,
    setFlocknoteSupport,
    setGeneralInquiry,
    setPrayerRequest,
  ]);

  return (
    <MainOptionButtonWrapper
      onClick={showGeneralInquiry}
      autoFocus={!flocknoteSupport && generalInquiry && !prayerRequest}
      DisplayComponent={GeneralInquiryButtonDisplay}
      data-cy="MemberToolbar_GeneralInquiryButton"
    />
  );
};

export default GeneralInquiryButton;
